import React from "react";
import Homecategory from "./Homecategory/Homecategory";
import Newproducts from "./Newproducts/Newproducts";
import Collection from "./Collection";
import MobileAppSection from "./MobileApp";
import Trandingproducts from "./Trendingproducts/Treandingproducts";
import Homesearch from "./HomeSearch/Homesearch";
import Countryslide from "./Countryslide/Countryslide";

const Home = () => {
  return (
    <>
      {/* <div className="bannerSec">
        <div className="bnrimg">
          <img src="assets/images/bnerimge.jpg" alt="" />
          <div className="bnrtxt">
            <div className="container">
              <div className="bnrtxtinr">
                <strong>Sell</strong>
                <h1>
                  Jewelry. <br /> Join the <br /> Market.
                </h1>
                <a href="#url" className="themebtn">
                  Sell your Jewelry
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="bnerForm">
          <div className="container">
            <div className="bnerfrmpnel">
              <div className="bnerlink">
                <nav>
                  <div className="nav nav-tabs" id="nav-tab" role="tablist">
                    <button
                      className="active"
                      id="nav-home-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#nav-home"
                      type="button"
                      role="tab"
                      aria-controls="nav-home"
                      aria-selected="true"
                    >
                      Shop By Style
                    </button>

                    <button
                      id="nav-profile-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#nav-profile"
                      type="button"
                      role="tab"
                      aria-controls="nav-profile"
                      aria-selected="false"
                    >
                      Start Selling
                    </button>
                  </div>
                </nav>
              </div>

              <div className="bneropen">
                <div className="tab-content" id="nav-tabContent">
                  <div
                    className="tab-pane fade show active"
                    id="nav-home"
                    role="tabpanel"
                    aria-labelledby="nav-home-tab"
                    tabIndex="0"
                  >
                    <div className="filterform">
                      <div className="flterhding">
                        <h2>Shop By Style</h2>
                        <a href="#" className="closeBtn">
                          Close
                        </a>
                      </div>

                      
                      <Countryslide />

                    
                      <div className="filterform">
                        
                        <div className="country-select">
                          <div className="select-box">
                            <span className="selected-text">
                              Search by Country
                            </span>
                          </div>

                          <ul
                            className="country-list"
                            style={{ display: "block" }}
                          >
                            <li data-value="algeria">
                              <img src="https://flagcdn.com/w20/dz.png" alt="" />
                              Algeria
                            </li>
                            <li data-value="argentina">
                              <img src="https://flagcdn.com/w20/ar.png" alt="" />
                              Argentina
                            </li>
                            <li data-value="australia">
                              <img src="https://flagcdn.com/w20/au.png" alt="" />
                              Australia
                            </li>
                            <li data-value="austria">
                              <img src="https://flagcdn.com/w20/at.png" alt="" />
                              Austria
                            </li>
                            <li data-value="bahrain">
                              <img src="https://flagcdn.com/w20/bh.png" alt="" />
                              Bahrain
                            </li>
                            <li data-value="brazil">
                              <img src="https://flagcdn.com/w20/br.png" alt="" />
                              Brazil
                            </li>
                            <li data-value="canada">
                              <img src="https://flagcdn.com/w20/ca.png" alt="" />
                              Canada
                            </li>
                            <li data-value="egypt">
                              <img src="https://flagcdn.com/w20/eg.png" alt="" />
                              Egypt
                            </li>
                          </ul>
                        </div>

                       
                        <div className="country-select">
                          <div className="select-box">
                            <span className="selected-text">
                              Main Selection
                            </span>
                          </div>
                          <ul className="country-list">
                            <li data-value="algeria">
                              <img src="https://flagcdn.com/w20/dz.png" alt="" />
                              Algeria
                            </li>
                            <li data-value="argentina">
                              <img src="https://flagcdn.com/w20/ar.png" alt="" />
                              Argentina
                            </li>
                            <li data-value="australia">
                              <img src="https://flagcdn.com/w20/au.png" alt="" />
                              Australia
                            </li>
                            <li data-value="austria">
                              <img src="https://flagcdn.com/w20/at.png" alt="" />
                              Austria
                            </li>
                            <li data-value="bahrain">
                              <img src="https://flagcdn.com/w20/bh.png" alt="" />
                              Bahrain
                            </li>
                            <li data-value="brazil">
                              <img src="https://flagcdn.com/w20/br.png" alt="" />
                              Brazil
                            </li>
                            <li data-value="canada">
                              <img src="https://flagcdn.com/w20/ca.png" alt="" />
                              Canada
                            </li>
                            <li data-value="egypt">
                              <img src="https://flagcdn.com/w20/eg.png" alt="" />
                              Egypt
                            </li>
                          </ul>
                        </div>

                        
                        <div className="country-select">
                          <div className="select-box">
                            <span className="selected-text">
                              Select Category
                            </span>
                          </div>
                          <ul className="country-list">
                            <li data-value="algeria">
                              <img src="https://flagcdn.com/w20/dz.png" alt="" />
                              Algeria
                            </li>
                            <li data-value="argentina">
                              <img src="https://flagcdn.com/w20/ar.png" alt="" />
                              Argentina
                            </li>
                            <li data-value="australia">
                              <img src="https://flagcdn.com/w20/au.png" alt="" />
                              Australia
                            </li>
                            <li data-value="austria">
                              <img src="https://flagcdn.com/w20/at.png" alt="" />
                              Austria
                            </li>
                            <li data-value="bahrain">
                              <img src="https://flagcdn.com/w20/bh.png" alt="" />
                              Bahrain
                            </li>
                            <li data-value="brazil">
                              <img src="https://flagcdn.com/w20/br.png" alt="" />
                              Brazil
                            </li>
                            <li data-value="canada">
                              <img src="https://flagcdn.com/w20/ca.png" alt="" />
                              Canada
                            </li>
                            <li data-value="egypt">
                              <img src="https://flagcdn.com/w20/eg.png" alt="" />
                              Egypt
                            </li>
                          </ul>
                        </div>
                      </div>

                      
                      <div className="frmbtnsrch">
                        <button>
                          <i>
                            <img src="assets/images/search.svg" alt="" />
                          </i>
                          Show Results
                        </button>
                      </div>
                    </div>
                  </div>

                  <div
                    className="tab-pane fade"
                    id="nav-profile"
                    role="tabpanel"
                    aria-labelledby="nav-profile-tab"
                    tabIndex="0"
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> */}
      <Homesearch />
      <Homecategory />
      <Newproducts />
      <Collection />
      <Trandingproducts />
      <MobileAppSection />
    </>
  );
};

export default Home;
